const sizes = {
  sm: { padding: "8px 14px", fontSize: "var(--text-sm)", height: 34 },
  md: { padding: "11px 20px", fontSize: "var(--text-base)", height: 42 },
  lg: { padding: "14px 26px", fontSize: "var(--text-md)", height: 52 },
};

const variants = {
  primary: { background: "var(--brand)", color: "var(--text-on-brand)", border: "1px solid transparent" },
  accent: { background: "var(--accent)", color: "var(--text-on-accent)", border: "1px solid transparent" },
  secondary: { background: "var(--surface-raised)", color: "var(--text-brand)", border: "1px solid var(--border-default)" },
  ghost: { background: "transparent", color: "var(--text-brand)", border: "1px solid transparent" },
  danger: { background: "var(--danger)", color: "#fff", border: "1px solid transparent" },
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  block = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  type = "button",
  onClick,
  style,
  ...rest
}) {
  const s = sizes[size] || sizes.md;
  const v = variants[variant] || variants.primary;

  const base = {
    display: block ? "flex" : "inline-flex",
    width: block ? "100%" : undefined,
    alignItems: "center",
    justifyContent: "center",
    gap: "var(--space-2)",
    fontFamily: "var(--font-body)",
    fontWeight: "var(--weight-semibold)",
    lineHeight: 1,
    letterSpacing: "var(--tracking-snug)",
    borderRadius: "var(--radius-pill)",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    whiteSpace: "nowrap",
    textDecoration: "none",
    transition:
      "transform var(--dur-fast) var(--ease-spring), filter var(--dur-base) var(--ease-standard), box-shadow var(--dur-base) var(--ease-standard)",
    padding: s.padding,
    fontSize: s.fontSize,
    minHeight: s.height,
    ...v,
    ...style,
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={base}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = "scale(0.96)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = ""; }}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.filter = "brightness(1.06)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.filter = ""; e.currentTarget.style.transform = ""; }}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  );
}
